import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import TrackPageView from "../../TrackPages";


const RouteProtection = () =>{
    const instructor_id = Cookies.get("instructor_id");
    const token = Cookies.get("token");;
    return(
        
        instructor_id && token?
                <>
                <TrackPageView />
                <Outlet/>
                </>
                :
                <Navigate to='/'/>

    )
};
export default RouteProtection;